import { defineComponent as _defineComponent } from 'vue';
import PaginationInfo from "@/components/ui/pagination/PaginationInfo.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaginatorInfo',
    props: {
        dataset: { type: null, required: true }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const props = __props;
        const __returned__ = { props, PaginationInfo };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
